import React, { Component } from "react"
import styled from "styled-components"
import { observer } from "mobx-react"

import Spacer from "~/components/Spacer"
import DOBInput from "./DOBInput"
import InputTitle from "./InputTitle"
import withTranslations from "~/components/_hocs/withTranslations"

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
`

@observer
class DOB extends Component {
  render() {
    return (
      <Wrap>
        <InputTitle>
          {this.props.translate("label")}
          <Spacer direction="width" mobile={11} desktop={11} />
        </InputTitle>
        <Spacer desktop={16} mobile={4} />
        <DOBInput />
      </Wrap>
    )
  }
}

export default withTranslations(DOB, "form.general.dateOfBirth")
